import { Blog } from "components/blog/blog.types";
import { DYLAN_LINKEDIN, LINKEDIN_URL } from "shared/constants/globals";

//Libum,Libum blog,Libum updates,Libum thoughts,Libum teamn updates

export const BLOG_ITEMS: Blog[] = [{
  id: 'we-have-a-blog',
  title: 'We Have a Blog?',
  description: `Fasten your seatbelts for our very first blog post.`,
  keywords: ['Libum', 'Libum blog', 'Libum vision', 'NexumAPI', 'Glaci', 'CU Build', 'Jack Henry Connect'],
  avatarPath: '/images/avatars/narwhal.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('06/16/2023'),
}, {
  id: 'cu-building-the-future',
  title: 'CU Build*ing the Future with Brilliant Minds and a Snack Mountain',
  description: 'Follow our journey through a weekend of innovation, collaboration, and snacks.',
  keywords: ['Libum', 'Libum blog', 'Libum API', 'NexumAPI', 'SymXchange integration', 'CU Build integrating partners'],
  avatarPath: '/images/avatars/flag.svg',
  author: 'The Founders',
  authorBio: 'Don Nguyen & Dylan Martinez',
  authorLabel: 'Founders',
  authorLink: LINKEDIN_URL,
  date: new Date('08/04/2023'),
}, {
  id: 'new-year-new-site',
  title: 'New Year, New Site',
  description: 'Keeping things fresh with a site revamp and a portal in the works.',
  keywords: ['Libum', 'Libum blog', 'Libum website', 'Libum portal', 'PowerOn Pro', 'NexumAPI', 'Glaci'],
  avatarPath: '/images/avatars/narwhal.svg',
  author: 'Dylan Martinez',
  authorBio: 'Co-Founder & Software Engineer',
  authorLabel: 'Dylan',
  authorLink: DYLAN_LINKEDIN,
  date: new Date('01/09/2025'),
}];
